<template lang="pug">
.main
  v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
    v-form(ref="form")
      v-text-field(color="primary" v-model="project.full_name" type="text" label="Full Name" @keyup.enter="validate" hint="*As shown in IC" outlined :rules="rules.fullName" persistent-hint)
      v-text-field(color="primary" v-model="project.ic_number" type="text" label="IC number" @keyup.enter="validate" outlined :rules="rules.icNumber")
      v-select(v-model="project.monthly_income" label="Monthly household income" outlined :items="incomes" item-text="text" item color="primary" return-object :rules="rules.income")
      v-file-input(v-model='uploadFiles' label='Photocopy of your IC' outlined multiple prepend-inner-icon='mdi-paperclip' prepend-icon='' show-size :rules="rules.document" accept="image/png, image/jpeg, image/bmp, application/pdf" hint="*Document size should be less than 10 MB" persistent-hint)
        template(v-slot:selection='{ text }')
          v-chip(small label color='primary')
            | {{ text }}
      y-checkbox.mt-0(v-model="agreedTerm" :rules="rules.agreedTerm" label="I hereby confirm that the information provided herein is accurate, correct and complete and that the document submitted along with this application form are genuine")
  
  .modals
    y-dialog(v-model='loading' persistent width='300')
      v-card(v-if="!hasResult" color='primary' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('processing_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('processing_text') }}

      v-card(v-if="isSuccess" color='success' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('success_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('success_text') }}

      v-card(v-if="isError" color='error' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('error_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('error_text') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ValidateProjectB40',
  props: ['proceed', 'company'],
  data: () => ({
    loading: false,
    hasResult: false,
    isSuccess: false,
    isError: false,
    uploadFiles: null,
    project: {
      id: null,
      full_name: '',
      ic_number: '',
      monthly_income: null,
      ic_photocopy: null
    },
    incomes: [
      {
        text: 'RM 0 - RM 2,360',
        value: 0,
        valid: true
      },
      {
        text: 'RM 2,361 - RM 3,360',
        value: 1,
        valid: true
      },
      {
        text: 'RM 3,361 - RM 4,360',
        value: 2,
        valid: true
      },
      {
        text: 'RM 4,361 - RM 5,360',
        value: 3,
        valid: true
      },
      {
        text: 'RM 5,361 - RM 6,360',
        value: 4,
        valid: true
      },
      {
        text: 'More than RM 6,360',
        value: 5,
        valid: true
      }
    ],
    agreedTerm: false,
    rules: {
      email: [
        v => !!v || 'E-mail address is required',
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      fullName: [
        v => !!v || 'Full name is required'
      ],
      icNumber: [
        v => !!v || 'IC number is required'
      ],
      income: [
        v => !!v || 'Household income is required'
      ],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ],
      document: [
        v => v !== null || 'This document is required',
        // v => !v || v.size < 10000000 || 'Document size should be less than 10 MB!'
      ]
    }
  }),
  mounted () {
    this.project.id = 'b40'
  },
  watch: {
    proceed () {
      this.validate()
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    validate() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.hasResult = false
      this.isSuccess = false
      this.isError = false
      setTimeout(() => {
        this.hasResult = true
        if (!this.project.monthly_income.valid) {
          this.isError = true
          setTimeout(() => {
            this.loading = false
          }, 3000)
          return
        }
        this.isSuccess = true
        var params = new FormData()
        params.append('file', this.uploadFiles[0])
        this.$axios.post(`/documents/`, params)
          .then(resp => {
            this.project.ic_photocopy = resp.data
            this.$emit('verified')
            this.loading = false
            this.axios.patch(`/companies/${this.company.id}/`, { extra_data: this.project })
          })
          .catch(() => {
            this.loading = false
            this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
          })
      }, 10000)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "processing_title": "Verifying your informations...",
    "processing_text": "Please wait and do not close or refresh this page",
    "success_title": "Congratulations!",
    "success_text": "You are elegible for this program",
    "error_title": "Ops..",
    "error_text": "Sorry, you are not eligible for this program."
  }
}
</i18n>